import React from 'react';
import { useTranslation } from 'react-i18next';

import type { QWSCodelistStatus } from '~/hooks/use-qws-codelist/useQWSCodelist';

import * as S from './QWSStatusView.styles';

export interface QWSStatusViewProps {
  status: QWSCodelistStatus;
  watchlistId?: string;
  error?: string;
  pendingNavigate?: boolean;
}

export const QWSStatusView = ({
  status,
  watchlistId,
  error,
  pendingNavigate = false,
}: QWSStatusViewProps): React.ReactElement | null => {
  const { t } = useTranslation('qws');

  const showLoading =
    status === 'loading' ||
    (status === 'done' && watchlistId) ||
    pendingNavigate;

  if (showLoading) {
    return (
      <S.Wrapper>
        <S.LoadingMessage>{t('resolving')}</S.LoadingMessage>
      </S.Wrapper>
    );
  }

  if (status === 'error') {
    const errorKey =
      error === 'noEntities' ? 'error.noEntities' : 'error.resolutionFailed';
    return (
      <S.Wrapper>
        <S.ErrorMessage>{t(errorKey)}</S.ErrorMessage>
      </S.Wrapper>
    );
  }

  return null;
};
